// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3257h","errorContainer":"styles_errorContainer__1mtyq","form":"styles_form__1OLHp","buttonContainer":"styles_buttonContainer__17V24"};